<template>
  <div
    class="claim-type-step-claim-item flex row-gap-3 col-gap-8 -pointer-events-none"
    :class="wrapperClasses"
  >
    <div class="claim-type-unit-wrapper w-full flex gap-6">
      <common-select-box-small
        class="mb-8 w-full pointer-events-none"
        :options="choices"
        :showTitle="false"
        :value="choices[0]"
      />
      <common-text-box-small
        class="mb-8 w-full claim-type-lon"
        :isDisabled="true"
      />
    </div>
    <div class="btn-area flex gap-3">
      <common-button
        class="save-btn-template"
        title="保存"
        type="filled"
        :click="() => {}"
        :btnStyle="{
          paddingLeft: 0,
          paddingRight: 0,
          width: '70px',
          height: '40px',
        }"
        disabled
      ></common-button>
      <common-button
        class="cancel-btn-template"
        type="border"
        color="#BDBDBD"
        :click="() => {}"
        :btnStyle="{
          paddingLeft: 0,
          paddingRight: 0,
          width: '70px',
          height: '40px',
          fontSize: '12px',
          pointerEvents: 'none',
        }"
        text-color="#757575"
        title="キャンセル"
      ></common-button>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import CommonButton from "../components/molecules/CommonButton.vue";
import CommonTextBoxSmall from "../components/molecules/CommonTextBoxSmall.vue";
import CommonSelectBoxSmall from "../components/molecules/CommonSelectBoxSmall.vue";

export default {
  components: {
    CommonButton,
    CommonTextBoxSmall,
    CommonSelectBoxSmall,
  },
  mixins: [ColorMixin],
  name: "O.ClaimTypeAmountOfMoney",
  props: {
    units: {
      type: Object,
      default() {
        return {};
      },
    },
    wrapperClasses: {
      type: Array, // Array<String>
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    choices() {
      return Object.keys(this.units).map(key => this.units[key].label);
    },
  },

  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
